import { Component, OnInit } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { BatchHistory, Covid19Batch, WellType } from '../agptesting-newview/model/covid19Batch';
import { AuthUtil } from '../common-services/auth-util';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { APGAdministrationService } from './apg-administration.service';
import { Comment } from '../agptesting-newview/model/comment';
import { CovidSamples } from '../agptesting-newview/model/covid-sample';
import { EventEnvelope } from './model/event';
import { UpdateBatchDateAndTimeDTO } from './model/updateBatchDateAndTimeDTO';
import { saveAs as saveByFileSaver } from "file-saver";
import { RunDetails } from '../runplan-process/model/RunDetails';
import { RunplanProcessService } from '../runplan-process/runplan-process.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { DatePipe } from '@angular/common';
import { RunplanSchedulerService } from '../runplan-scheduler/runplan-scheduler.service';
import { RunComment } from '../agptesting-newview/model/runComment';
import { Order } from './model/order';
import { invoiceDateFormat } from './model/invoice-export';

@Component({
  selector: 'app-apg-administration',
  templateUrl: './apg-administration.component.html',
  styleUrls: ['./apg-administration.component.css']
})
export class ApgAdministrationComponent implements OnInit {


  dateValue: Date;
  requestJson: string;
  searchSelection:string;
  selectedLabId: string;
  searchedBatch: Covid19Batch;
  searchSuccess = false;
  selectedResetStatus: string;
  locked:boolean;
  msgs:string;
  rushSample:boolean;
  updateBatchDateAndTime: UpdateBatchDateAndTimeDTO;
  readonly blueberryAPGBatchAction = 'BlueberryAPGBatchActionUsers';
  readonly blueberryAPGEBEUser = 'BlueberryAPGEbersbergLabUsers';
  readonly blueberryDenmarkUser = 'BlueberryAPGDenmarkLabUsers';
  readonly blueberryDenmarkBatchAction = 'BlueberryAPGDenmarkBatchActionUsers';

  readonly blueberryNetherlandsUser = 'BlueberryAPGNederlandLabUsers';
  readonly blueberryCPHUser = 'BlueberryAPGCopenhagenLabUsers';
  readonly blueberryNetherlandsBatchAction = 'BlueberryAPGNederlandBatchActionUsers';
  readonly blueberryCPHBatchAction = 'BlueberryAPGCopenhagenBatchActionUsers';
  readonly blueberryCologneUser = 'BlueberryAPGCologeneLabUsers';
  readonly blueberryCologneBatchAction = 'BlueberryAPGCologeneBatchActionUsers';
  readonly blueberrySwedenUser = 'BlueberryAPGSwedenUppsalaLabUsers';
  readonly blueberryswedenBatchAction = 'BlueberryAPGSwedenUppsalaBatchActionUsers';
  readonly blueberryAPGNGSKonstanzLabUsersBatchActionUsers ='BlueberryAPGNGSKonstanzLabUsersBatchActionUsers';
  readonly blueberryAPGNGSKonstanzLabUsers = 'BlueberryAPGNGSKonstanzLabUsers';
  readonly blueberryUKDTCPopGenBatchActionUsers ='BlueberryUKDTCPopGenBatchActionUsers';
  readonly blueberryUKDTCPopGenLabUsers ='BlueberryUKDTCPopGenLabUsers';
  validRole: boolean;
  mapOfStatusCalls = new Map();
  mapOfStatusWithDateFields = new Map();
  mapOfStatusWithPuidFields = new Map();
  puid: string;
  blocked = false;
  sampleSearch: boolean = false;
  sampleInfo: any;
  showCommentDialog = false;
  commentsMap = new Map<string, Comment[]>();
  batchCommentVisibility: Map<string, boolean>;
  runCommentsMap = new Map<string, RunComment[]>();
  runCommentVisibility: Map<string, boolean>;
  newRunComment: RunComment;
  previewComment: RunComment;
  batchID: string;
  batchIdPopup: boolean = false;
  batchIdToDeleteSample: string;
  redoReasonsPopup: boolean = false;
  selectedRedoReason: string;
  enteredRedoReason: string;
  selectedRedoStep: string;
  redoReasons: any[];
  runSearchOptions:any[];
  runMachineOptions:SelectItem[];
  selectedRunSearch:string;
  inputRunId:string;
  selectedRun:RunDetails;
  sequencerType:string;
  runStatus:string;
  startDate:Date=null;
  runMachine:any;
  readMode:string;
  flowcell:string;
  runDetailShow:boolean;
  runReschedulePopup:boolean=false;
  overlapRunList:any[]=[];
  runCommentList:any[]=[];
  showRunCommentDialog:boolean=false;
  flowCellDurationMap: Map<string, any> = new Map();
  runDuration:any;
  selectedLab:any;

  errorHandler: ErrorHandler = new ErrorHandler;
  removeUnnecessaryPopup: boolean = false;
  parentBatches: string[];
  selectedBatchIdToComplete: string;

  searchFilterList:any[];
  selectedSearchFilter:any;
  valueToSearch : string;
  newBatchID : string;
  deliveryTargetDate: any;
  statusSelectionList:any[];
  headers = [
    {field:'Artic Batch/Sample',value:'batch'},
    {field:'Midplex Orders', value:'order'},
    {field:'Runs Data ',value:'library'}
  ];
  selectedTab: string;
  validationErrors: string[];
  dateFormat: string;
  dateTimeFormat:string;
  fixdelivery: string;
  deliveryId: string;
  deliveryOrdersList: Array<any>;
  title: string = 'Delivery orders';
  deliveryOrdersCols: any[];
  selectedDeliveryOrder: Order;
  showDeliveryOrder: boolean;
  dateFields: string[] = ['receivedDate','completedDate',
    'STR-date','SNP-date','TEST-date'];
  boolenFields: string[] = ['reused','STR', 'STR-P', 'SNP', 'SNP-P', 'TEST'];
  buttonFields:string[]=['action'];
  fromDate: Date;
  untilDate: Date;

  constructor(private _messagesService: MessagesService, private runPlanSchedulerService: RunplanSchedulerService,
     private datepipe: DatePipe, private confirmationService: ConfirmationService, private apgAdminService: APGAdministrationService, private runplanProcessService: RunplanProcessService, private masterDataMDMService: MasterDataService, private datePipe: DatePipe) { }

  setDateFormat(dateFormat){
    return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
  }
  ngOnInit() {

    this.runDetailShow=false;
    this.selectedRun = new RunDetails();
    this.newRunComment = new RunComment();
    this.previewComment = new RunComment();

    this.searchFilterList = [
      {label:'Batch Id',value:'BatchId'},
      {label:'Sample Id',value:'SampleId'},
      {label:'External Id',value:'ExternalId'},
      {label:'Library Id',value:'LibraryId'}
    ];

    this.runSearchOptions = [
      {label:'RunId', value:'runId'}
    ]

    this.selectedRunSearch =  'runId'

    this.selectedSearchFilter = "BatchId"
    this.selectedLab = JSON.parse(localStorage.getItem('lab')).lab
    this.selectedLabId = this.selectedLab._id;
    this.dateFormat =this.setDateFormat(this.selectedLab.dateFormat.toLowerCase());
    this.dateTimeFormat= this.selectedLab.dateTimeFormat;
    this.puid = localStorage.getItem('PUID');
    this.validRole = this.decideIfBBRoleExists();
    this.mapOfStatusCalls.set("CREATE_BATCH", "createBatch");
    this.mapOfStatusCalls.set("BATCH_UPLOADED", "uploadBatch");
    this.mapOfStatusCalls.set("BATCH_RECEIVED", "receiveBatch");
    this.mapOfStatusCalls.set("START_ARTIC_POOLING", "startArticPooling");
    this.mapOfStatusCalls.set("COMPLETE_ARTIC_POOLING", "completeArticPooling");
    this.mapOfStatusCalls.set("START_ARTIC_PURIFICATION", "startArticPurification");
    this.mapOfStatusCalls.set("COMPLETE_ARTIC_PURIFICATION", "completeArticPurification");
    this.mapOfStatusCalls.set("CONTROLS_ADDED", "controlsAdded");
    this.mapOfStatusCalls.set("START_ARTIC_QC", "startArticQC");
    this.mapOfStatusCalls.set("COMPLETE_ARTIC_QC", "completeArticQC");
    this.mapOfStatusCalls.set("START_END_REPAIR", "startEndRepair");
    this.mapOfStatusCalls.set("COMPLETE_END_REPAIR", "completeEndRepair");
    this.mapOfStatusCalls.set("START_LIB_QC", "startLibQC");
    this.mapOfStatusCalls.set("COMPLETE_LIB_QC", "completeLibQC");
    this.mapOfStatusCalls.set("START_cDNA", "startcDNA");
    this.mapOfStatusCalls.set("COMPLETE_cDNA", "completecDNA");
    this.mapOfStatusCalls.set("START_ADAPTER_LIGATION", "startAdapterLigation");
    this.mapOfStatusCalls.set("COMPLETE_ADAPTER_LIGATION", "completeAdapterLigation");
    this.mapOfStatusCalls.set("START_ARTIC_PCR", "startArticPCR");
    this.mapOfStatusCalls.set("COMPLETE_ARTIC_PCR", "completeArticPCR");
    this.mapOfStatusCalls.set("START_NORMALIZATION", "startNormalization");
    this.mapOfStatusCalls.set("COMPLETE_NORMALIZATION", "completeNormalization");
    this.mapOfStatusCalls.set("START_PURIFICATION_2", "startPurification2");
    this.mapOfStatusCalls.set("COMPLETE_PURIFICATION_2", "completePurification2");
    this.mapOfStatusCalls.set("START_LIB_POOLING", "startLibPooling");
    this.mapOfStatusCalls.set("COMPLETE_LIB_POOLING", "completeLibPooling");
    this.mapOfStatusCalls.set("START_FINAL_QC", "startFinalQC");
    this.mapOfStatusCalls.set("COMPLETE_FINAL_QC", "completeFinalQC");
    this.mapOfStatusCalls.set("START_TAG_PCR", "startTagPCR");
    this.mapOfStatusCalls.set("COMPLETE_TAG_PCR", "completeTagPCR");
    this.mapOfStatusCalls.set("TRANSFER_SEQUENCING", "transferSequencing");
    this.mapOfStatusCalls.set("START_SEQUENCING_RUN", "startSequencing");
    this.mapOfStatusCalls.set("COMPLETE_SEQUENCING_RUN", "completeSequencing");
    this.mapOfStatusCalls.set("START_PRIMARY_ANALYSIS", "startPrimaryAnalysis");
    this.mapOfStatusCalls.set("COMPLETE_PRIMARY_ANALYSIS", "completePrimaryAnalysis");
    this.mapOfStatusCalls.set("START_SECONDARY_ANALYSIS", "startSecondaryAnalysis");
    this.mapOfStatusCalls.set("COMPLETE_SECONDARY_ANALYSIS", "startSecondaryAnalysis");
    this.mapOfStatusCalls.set("START_DATA_REVIEW", "startDataReview");
    this.mapOfStatusCalls.set("START_DELIVERY", "startDelivery");
    this.mapOfStatusCalls.set("READY_FOR_DELIVERY", "readyForDelivery");
    this.mapOfStatusCalls.set("COMPLETED", "delivered");
    this.mapOfStatusCalls.set("INVOICED", "invoiced");
    this.mapOfStatusCalls.set("MERGED", "merged");
    this.mapOfStatusCalls.set("START_PCR", "startPCR");
    this.mapOfStatusCalls.set("COMPLETE_PCR", "completePCR");
    this.mapOfStatusCalls.set("START_POOLING", "startPooling");
    this.mapOfStatusCalls.set("START_PURIFICATION", "startPurification");
    this.mapOfStatusCalls.set("COMPLETE_PURIFICATION", "completePurification");
    this.mapOfStatusCalls.set("COMPLETE_POOLING", "completePooling");

    this.redoReasons = [
      { value: 'PCR_NTC contamination', label: '01 - PCR_NTC contamination' },
      { value: 'PCR_PC negative', label: '02 - PCR_PC negative' },
      { value: 'PCR_PC Out of range', label: '03 - PCR_PC Out of range' },
      { value: '384 ICR failure (random over all 4 plates)', label: '04 - 384 ICR failure (random over all 4 plates)' },
      { value: '96 ICR failure (one plate)', label: '05 - 96 ICR failure (one plate)'},
      { value: 'Sample contamination', label: '06 - Sample contamination' },
      { value: 'POS_EX negative', label: '07 - POS_EX negative' },
      { value: 'NTC_EX contamination', label: '08 - NTC_EX contamination' },
      { value: '96 plate rotated', label: '09 - 96 plate rotated' },
      { value: '96 plate switched', label: '10 - 96 plate switched'},
      { value: 'Other', label: '99 - Other'}
    ];

    this.searchedBatch = new Covid19Batch();
    this.deliveryOrdersCols=[
      { field: 'delivery', header: 'Delivery', showInGrid: true },
      { field: 'sampleId', header: 'Sample ID', showInGrid: true },
      { field: 'reused', header: 'Reused', showInGrid: true },
      { field: 'STR', header: 'STR', showInGrid: true },
      { field: 'STR-P', header: 'STR-P', showInGrid: true },
      { field: 'SNP', header: 'SNP', showInGrid: true },
      { field: 'SNP-P', header: 'SNP-P', showInGrid: true },
      { field: 'TEST', header: 'TEST', showInGrid: true },
      { field: 'status', header: 'Order Status', showInGrid: true },
      { field: 'sampleStatus', header: 'Sample Status', showInGrid: true },
      { field: 'receivedDate', header: 'Received Date', showInGrid: true },
      { field: 'completedDate', header: 'Completed Date', showInGrid: true },
      { field: 'STR-date', header: 'STR Invoiced', showInGrid: true },
      { field: 'SNP-date', header: 'SNP Invoiced', showInGrid: true },
      { field: 'TEST-date', header: 'TEST Invoiced', showInGrid: true },
      { field: 'error', header: 'Error', showInGrid: true },
      { field:'action', header:'Action', showInGrid:true}
    ];
    this.showDeliveryOrder=false;
  }

  decideIfBBRoleExists() {
    let roles = this.getRolesFromAccessToken();
    if(roles.length <= 0) {
      return false
    }
    
    return (
      (roles.includes(this.blueberryAPGNGSKonstanzLabUsersBatchActionUsers) && roles.includes(this.blueberryAPGNGSKonstanzLabUsers))
      || (roles.includes(this.blueberryUKDTCPopGenBatchActionUsers) && roles.include(this.blueberryUKDTCPopGenLabUsers))
    );
  }

  getRolesFromAccessToken() {
    let authUtil = new AuthUtil()
    let accessToken = authUtil.getAccessToken()
    if(accessToken)
    {
      let access_token = jwt_decode(accessToken);
      return access_token.roles;
    }
    return [];
  }

  search(searchID: string) {
    this.searchSuccess = false;
    this.sampleSearch = false;
    this.searchSelection="";
    if(this.selectedSearchFilter == 'BatchId' || this.selectedSearchFilter == 'ExternalId' || this.selectedSearchFilter == 'LibraryId') {
      this.searchForBatch(searchID.trim())
    }
    else{
      this.searchForSample(searchID.trim());
    }
  }

  searchForBatch(searchValue: string) {
    if(!searchValue || searchValue.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to search' });
      return;
    }
    this.dateValue=null;
    this.blocked = true;
    this.apgAdminService.getBatchForLabAndBatchId(this.selectedLabId,this.selectedSearchFilter, searchValue.trim()).subscribe(
      result => {
        if(result.data && result.data != null){
          this.searchedBatch = result.data;
          if(this.searchedBatch.batchReceivedDateTime) {
            this.dateValue = new Date(this.searchedBatch.batchReceivedDateTime);
          }
          this.commentsMap = new Map<string, Comment[]>();
          this.batchCommentVisibility = new Map<string, boolean>();
          this.batchID = this.searchedBatch.batchID;
          this.resetBatchData();
          this.searchSuccess = true;
         this.showMessageForSearchBatch(searchValue);
         this.populateUpdateStatusDropList();
        }
        else{
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with '+this.selectedSearchFilter +' '+ searchValue.trim() });
        }
        this.blocked = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  populateUpdateStatusDropList() {
    if(this.searchedBatch.workflowGroup ==='Artic'){
      this.statusSelectionList = [
        { label: 'Create Batch', value: "CREATE_BATCH" },
        { label: 'Upload Batch', value: "BATCH_UPLOADED" },
        { label: 'Receive Batch', value: "BATCH_RECEIVED" },
        { label: 'Controls Added', value: "CONTROLS_ADDED" },
        { label: 'Start cDNA', value: "START_cDNA" },
        { label: 'Complete cDNA', value: "COMPLETE_cDNA" },
        { label: 'Start Artic PCR', value: "START_ARTIC_PCR" },
        { label: 'Complete Artic PCR', value: "COMPLETE_ARTIC_PCR" },
        { label: 'Start ARTIC Pooling', value: "START_ARTIC_POOLING" },
        { label: 'Complete ARTIC Pooling', value: "COMPLETE_ARTIC_POOLING" },
        { label: 'Start ARTIC Purification', value: "START_ARTIC_PURIFICATION" },
        { label: 'Complete ARTIC Purification', value: "COMPLETE_ARTIC_PURIFICATION" },
        { label: 'Start Artic QC', value: "START_ARTIC_QC" },
        { label: 'Complete Artic QC', value: "COMPLETE_ARTIC_QC" },
        { label: 'Start Normalization', value: "START_NORMALIZATION" },
        { label: 'Complete Normalization', value: "COMPLETE_NORMALIZATION" },
        { label: 'Start End Repair', value: "START_END_REPAIR" },
        { label: 'Complete End Repair', value: "COMPLETE_END_REPAIR" },
        { label: 'Start Adapter Ligation', value: "START_ADAPTER_LIGATION" },
        { label: 'Complete Adapter Ligation', value: "COMPLETE_ADAPTER_LIGATION" },
        { label: 'Start Purification 2', value: "START_PURIFICATION_2" },
        { label: 'Complete Purification 2', value: "COMPLETE_PURIFICATION_2" },
        { label: 'Start Tag PCR', value: "START_TAG_PCR" },
        { label: 'Complete Tag PCR', value: "COMPLETE_TAG_PCR" },
        { label: 'Start Lib QC', value: "START_LIB_QC" },
        { label: 'Complete Lib QC', value: "COMPLETE_LIB_QC" },
        { label: 'Start Lib Pooling', value: "START_LIB_POOLING" },
        { label: 'Complete Lib Pooling', value: "COMPLETE_LIB_POOLING" },
        { label: 'Start Final QC', value: "START_FINAL_QC" },
        { label: 'Complete Final QC', value: "COMPLETE_FINAL_QC" },
        { label: 'Transfer To Sequencing', value: "TRANSFER_SEQUENCING" },
        { label: 'Start Sequencing Run', value: "START_SEQUENCING_RUN" },
        { label: 'Complete Sequencing Run', value: "COMPLETE_SEQUENCING_RUN" },
        { label: 'Start Primary Analysis', value: "START_PRIMARY_ANALYSIS" },
        { label: 'Complete Primary Analysis', value: "COMPLETE_PRIMARY_ANALYSIS" },
        { label: 'Start Secondary Analysis', value: "START_SECONDARY_ANALYSIS" },
        { label: 'Complete Secondary Analysis', value: "COMPLETE_SECONDARY_ANALYSIS" },
        { label: 'Start Data Review', value: "START_DATA_REVIEW" },
        { label: 'Ready For Delivery', value: "READY_FOR_DELIVERY" },
        { label: 'Start Delivery', value: "START_DELIVERY" },
        { label: 'Delivered', value: "COMPLETED" },
        { label: 'Invoiced', value: "INVOICED" },
        { label: 'Redo', value: "REDO" },
        { label: 'Archived', value: "ARCHIVED" }
      ];
    }else if(this.searchedBatch.workflowGroup !=='Artic' && this.searchedBatch.wellType == WellType.WELL96 ) {
      this.statusSelectionList = [
        { label: 'Controls Added', value: "CONTROLS_ADDED" },
        { label: 'Redo', value: "REDO" }
      ];
    }else if(this.searchedBatch.workflowGroup !=='Artic' && this.searchedBatch.wellType == WellType.WELL384){
      this.statusSelectionList = [
        { label: 'Merged', value: "MERGED" },
        { label: 'Start PCR', value: "START_PCR" },
        { label: 'Complete PCR', value: "COMPLETE_PCR" },
        { label: 'Start Pooling', value: "START_POOLING" },
        { label: 'Complete Pooling', value: "COMPLETE_POOLING" },
        { label: 'Start Tag PCR', value: "START_TAG_PCR" },
        { label: 'Complete Tag PCR', value: "COMPLETE_TAG_PCR" },
        { label: 'Start Lib Pooling', value: "START_LIB_POOLING" },
        { label: 'Complete Lib Pooling', value: "COMPLETE_LIB_POOLING" },
        { label: 'Start Purification', value: "START_PURIFICATION" },
        { label: 'Complete Purification', value: "COMPLETE_PURIFICATION" },
        { label: 'Start Lib QC', value: "START_LIB_QC" },
        { label: 'Complete Lib QC', value: "COMPLETE_LIB_QC" },
        { label: 'Transfer Sequencing', value: "TRANSFER_SEQUENCING" },
        { label: 'Start Sequencing', value: "START_SEQUENCING_RUN" },
        { label: 'Complete Sequencing', value: "COMPLETE_SEQUENCING_RUN" },
        { label: 'Start Data Review', value: "START_DATA_REVIEW" },
        { label: 'Delivered', value: "COMPLETED" },
        { label: 'Redo', value: "REDO" }
      ];
    }

  }
  showMessageForSearchBatch(searchValue:string): any {
    if(this.searchedBatch.matchedBatchCount == 1){
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Batch Found!',
        detail: 'Batch for ' + searchValue + ' is Found.'});
    }else if([2,3,4,5].includes(this.searchedBatch.matchedBatchCount)){
      this._messagesService.addWarningMessage({
      severity: 'warn',
      summary: 'Multiple Batchs Found',
      detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.searchedBatch.matchedBatchCount+' Batch Id\'s are : '
      +this.searchedBatch.matchedBatchIDs});
    }else if(this.searchedBatch.matchedBatchCount>1) {
      this._messagesService.addWarningMessage({
        severity: 'warn',
        summary: 'Multiple Batchs Found',
        detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.searchedBatch.matchedBatchCount});
    }
  }
  redoDisabled() {
    return !this.searchedBatch || this.searchedBatch.statusOfTheBatch == 'MERGE_STARTED' || this.isMergedBatch() || ['REDO', 'REMOVED'].includes(this.searchedBatch.statusOfTheBatch) || !this.validRole;
  }

  resetStatus() {
    if(this.searchedBatch.statusOfTheBatch ==="COMPLETED"){
      this._messagesService.addErrorMessage({
        severity: 'error',summary: 'Batch Update Error!',
        detail: 'Updating the status of a batch that has already been delivered is forbidden to omit inconsistency with the invoicing.'
      });
      return;
    }
    if(this.searchedBatch.statusOfTheBatch ==="INVOICED"){
      this._messagesService.addErrorMessage({
        severity: 'error',summary: 'Batch Update Error!',
        detail: 'Updating the status of a batch that has already been invoiced is forbidden to omit inconsistency with the invoicing.'
      });
      return;
    }
    let dialogMessage = 'Do you really want to update the Batch ' + this.searchedBatch.batchID + '?';
    this.confirmationService.confirm({
      message: dialogMessage,
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        let functionName = this.mapOfStatusCalls.get(this.selectedResetStatus);
        this[functionName](this.selectedResetStatus);
      },
      reject: () => {
        this.selectedResetStatus = null;
      }
    });
  }

  startArticPurification(status: string){
    this.searchedBatch.startArticPurificationDateTime = new Date();
    this.searchedBatch.startArticPurificationPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticPurification(status: string){
    this.searchedBatch.completeArticPurificationDateTime = new Date();
    this.searchedBatch.completeArticPurificationPUID = this.puid;
    this.updateBatch(status);
  }
  startPrimaryAnalysis(status: string){
    this.searchedBatch.startPrimaryAnalysisDateTime = new Date();
    this.searchedBatch.startPrimaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  completePrimaryAnalysis(status: string){
    this.searchedBatch.completePrimaryAnalysisDateTime = new Date();
    this.searchedBatch.completePrimaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  startSecondaryAnalysis(status: string){
    this.searchedBatch.startSecondaryAnalysisDateTime = new Date();
    this.searchedBatch.startSecondaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  completeSecondaryAnalysis(status: string){
    this.searchedBatch.completeSecondaryAnalysisDateTime = new Date();
    this.searchedBatch.completeSecondaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  startDataReview(status: string){
    this.searchedBatch.startDataReviewDateTime = new Date();
    this.searchedBatch.startDataReviewPUID = this.puid;
    this.updateBatch(status);
  }
  startDelivery(status: string){
    this.searchedBatch.startDeliveryDateTime = new Date();
    this.searchedBatch.startDeliveryPUID = this.puid;
    this.updateBatch(status);
  }
  readyForDelivery(status: string){
    this.searchedBatch.readyForDeliveryDateTime = new Date();
    this.searchedBatch.readyForDeliveryPUID = this.puid;
    this.updateBatch(status);
  }
  delivered(status: string){
    this.searchedBatch.deliveryCompletionDateTime = new Date();
    this.searchedBatch.deliveryCompletionPUID = this.puid;
    this.updateBatch(status);
  }
  invoiced(status: string){
    this.searchedBatch.invoicedDateTime = new Date();
    this.searchedBatch.invoicedPUID = this.puid;
    this.updateBatch(status);
  }
  completePurification2(status: string){
    this.searchedBatch.completePurification2DateTIme = new Date();
    this.searchedBatch.completePurification2PUID = this.puid;
    this.updateBatch(status);
  }
  startLibPooling(status: string){
    this.searchedBatch.startLibPoolingDateTime = new Date();
    this.searchedBatch.startLibPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  completeLibPooling(status: string){
    this.searchedBatch.completeLibPoolingDateTime = new Date();
    this.searchedBatch.completeLibPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  startTagPCR(status: string){
    this.searchedBatch.startTagPCRDateTime = new Date();
    this.searchedBatch.startTagPCRPUID = this.puid;
    this.updateBatch(status);
  }
  completeTagPCR(status: string){
    this.searchedBatch.completeTagPCRDateTime = new Date();
    this.searchedBatch.completeTagPCRPUID = this.puid;
    this.updateBatch(status);
  }
  transferSequencing(status: string){
    this.searchedBatch.transferSequencingDateTime = new Date();
    this.searchedBatch.transferSequencingPUID = this.puid;
    this.updateBatch(status);
  }
  startSequencing(status: string){
  this.searchedBatch.startSequencingDateTime = new Date();
  this.searchedBatch.startSequencingPUID = this.puid;
  this.updateBatch(status);
  }
  completeSequencing(status: string){
    this.searchedBatch.completedSequencingDateTime = new Date();
    this.searchedBatch.completedSequencingPUID = this.puid;
    this.updateBatch(status);
  }
  completeEndRepair(status: string){
    this.searchedBatch.completeEndRepairDateTime = new Date();
    this.searchedBatch.completeEndRepairPUID = this.puid;
    this.updateBatch(status);
  }
  startLibQC(status: string){
    this.searchedBatch.startLibQCDateTime = new Date();
    this.searchedBatch.startLibQCPUID = this.puid;
    this.updateBatch(status);
  }
  completeLibQC(status: string){
    this.searchedBatch.completeLibQCDateTime = new Date();
    this.searchedBatch.completeLibQCPUID = this.puid;
    this.updateBatch(status);
  }
  startcDNA(status: string){
    this.searchedBatch.startcDNADateTime = new Date();
    this.searchedBatch.startcDNAPUID = this.puid;
    this.updateBatch(status);
  }
  completecDNA(status: string){
    this.searchedBatch.completecDNADateTime = new Date();
    this.searchedBatch.completecDNAPUID = this.puid;
    this.updateBatch(status);
  }
  startAdapterLigation(status: string){
    this.searchedBatch.startAdapterLigationDateTime = new Date();
    this.searchedBatch.startAdapterLigationPUID = this.puid;
    this.updateBatch(status);
  }
  completeAdapterLigation(status: string){
    this.searchedBatch.completeAdapterLigationDateTime = new Date();
    this.searchedBatch.completeAdapterLigationPUID = this.puid;
    this.updateBatch(status);
  }
  startArticPCR(status: string){
    this.searchedBatch.startArticPCRDateTime = new Date();
    this.searchedBatch.startArticPCRPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticPCR(status: string){
    this.searchedBatch.completeArticPCRDateTime = new Date();
    this.searchedBatch.completeArticPCRPUID = this.puid;
    this.updateBatch(status);
  }
  startNormalization(status: string){
    this.searchedBatch.startNormalizationDateTime = new Date();
    this.searchedBatch.startNormalizationPUID = this.puid;
    this.updateBatch(status);
  }
  completeNormalization(status: string){
    this.searchedBatch.completeNormalizationDateTime = new Date();
    this.searchedBatch.completeNormalizationPUID = this.puid;
    this.updateBatch(status);
  }
  startPurification2(status: string){
    this.searchedBatch.startPurification2DateTIme = new Date();
    this.searchedBatch.startPurification2PUID = this.puid;
    this.updateBatch(status);
  }
  uploadBatch(status: string){
    this.searchedBatch.batchUploadedDateTime = new Date();
    this.searchedBatch.batchUploadedPUID = this.puid;
    this.updateBatch(status);
  }
  receiveBatch(status: string){
    this.searchedBatch.batchReceivedDateTime = new Date();
    this.searchedBatch.batchReceivedPUID = this.puid;
    this.updateBatch(status);
  }
  startArticPooling(status: string){
    this.searchedBatch.startArticPoolingDateTime = new Date();
    this.searchedBatch.startArticPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticPooling(status: string){
    this.searchedBatch.completeArticPoolingDateTime = new Date();
    this.searchedBatch.completeArticPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  startPurification1(status: string){
    this.searchedBatch.startPurification1DateTIme = new Date();
    this.searchedBatch.startPurification1PUID = this.puid;
    this.updateBatch(status);
  }
  completePurification1(status: string){
    this.searchedBatch.completePurification1DateTIme = new Date();
    this.searchedBatch.completePurification1PUID = this.puid;
    this.updateBatch(status);
  }
  startPurification3(status: string){
    this.searchedBatch.startPurification3DateTIme = new Date();
    this.searchedBatch.startPurification3PUID = this.puid;
    this.updateBatch(status);
  }
  completePurification3(status: string){
    this.searchedBatch.completePurification3DateTIme = new Date();
    this.searchedBatch.completePurification3PUID = this.puid;
    this.updateBatch(status);
  }
  controlsAdded(status: string){
    this.searchedBatch.controlsAddedDateTime = new Date();
    this.searchedBatch.controlsAddedPUID = this.puid;

    this.updateBatch(status);
  }
  startArticQC(status: string){
    this.searchedBatch.startArticQCDateTime = new Date();
    this.searchedBatch.startArticQCPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticQC(status: string){
    this.searchedBatch.completeArticQCDateTime = new Date();
    this.searchedBatch.completeArticQCPUID = this.puid;
    this.updateBatch(status);
  }
  startEndRepair(status: string){
    this.searchedBatch.startEndRepairDateTime = new Date();
    this.searchedBatch.startEndRepairPUID = this.puid;
    this.updateBatch(status);
  }
  startFinalQC(status: string){
    this.searchedBatch.startFinalQCDateTime = new Date();
    this.searchedBatch.startFinalQCPUID = this.puid;
    this.updateBatch(status);
  }
  completeFinalQC(status: string){
    this.searchedBatch.completeFinalQCDateTime = new Date();
    this.searchedBatch.completeFinalQCPUID = this.puid;
    this.updateBatch(status);
  }

  createBatch(status: string){
    this.searchedBatch.receptionDateTime = new Date();
    this.searchedBatch.puidUnboxing = this.puid;
    this.updateBatch(status);
  }
  merged(status: string){
    this.searchedBatch.mergeCompleteDateTime = new Date();
    this.searchedBatch.mergeCompletePUID= this.puid;
    this.updateBatch(status);
  }
  startPCR(status: string){
    this.searchedBatch.startPcrDateTime = new Date();
    this.searchedBatch.startPcrPUID= this.puid;
    this.updateBatch(status);
  }
  completePCR(status: string){
    this.searchedBatch.completePcrDateTime = new Date();
    this.searchedBatch.completePcrPUID= this.puid;
    this.updateBatch(status);
  }
  startPooling(status: string){
    this.searchedBatch.startPoolingDateTime = new Date();
    this.searchedBatch.startPoolingPUID= this.puid;
    this.updateBatch(status);
  }
  completePooling(status: string){
    this.searchedBatch.completePoolingDateTime = new Date();
    this.searchedBatch.completePoolingPUID= this.puid;
    this.updateBatch(status);
  }
  startPurification(status: string){
    this.searchedBatch.startPurificationDateTime = new Date();
    this.searchedBatch.startPurificationPUID = this.puid;
    this.updateBatch(status);
  }
  completePurification(status: string){
    this.searchedBatch.completePurificationDateTime = new Date();
    this.searchedBatch.completePurificationPUID = this.puid;
    this.updateBatch(status);
  }
  updateBatch(statusOfBatch: string) {
    this.updateCommentsForBatchUpdate(statusOfBatch);
    this.searchedBatch.statusOfTheBatch = statusOfBatch;
    this.searchedBatch.previousStatusOfTheBatch = statusOfBatch;
    this.saveBatchData();
  }
  disableUpdateBatch(){
    return !this.validRole || (this.enableUpdateButton() && !this.selectedResetStatus);
  }
  enableUpdateButton(){
    return this.rushSample == this.searchedBatch.rushSample && this.locked == this.searchedBatch.locked;
  }
  saveBatchData() {
    this.searchedBatch.lab = this.selectedLabId;
    this.searchedBatch.userID = this.puid;
    this.blocked = true;
    this.apgAdminService.changeBatchStatus(this.searchedBatch).subscribe(
      result => {
        if (result.data) {
          this.searchedBatch = result.data;
          this.resetBatchData();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.searchedBatch.batchID + ' has been updated successfully'
          });
        this.blocked = false;
      }
      },
      error => {
        this.showError(error);
      }
    );
  }

  private showError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  resetBatchData() {
    this.rushSample = this.searchedBatch.rushSample;
    this.locked = this.searchedBatch.locked;
  }
  redoAction() {
    this.confirmationService.confirm({
      message: 'Do you really want to Redo ' + this.searchedBatch.batchID + '?',
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        let redosearchedBatch = this.searchedBatch;
        redosearchedBatch.redoStatus = this.selectedRedoStep;
        redosearchedBatch.redoReason = this.selectedRedoReason != 'Other' ? this.selectedRedoReason : this.enteredRedoReason;

        redosearchedBatch.redoDateTime = new Date();
        redosearchedBatch.redoPUID = this.puid;
        this.blocked = true;
        this.apgAdminService.redoBatchService(redosearchedBatch).subscribe(
          result => {
            if (result.data) {
              this.searchedBatch = result.data;
              this._messagesService.addSuccessMessage({
                severity: 'success', summary: 'Redo Batch Created!',
                detail: 'Redo Batch ' + result.data.batchID + ' has been created for user ' + this.puid,
              });
              this.selectedRedoReason = null;
              this.selectedRedoStep = null;
              this.enteredRedoReason = null;
              this.redoReasonsPopup = false;
            }
            this.blocked = false;
          },
          error => {
            this.blocked = false;
            let message = this.errorHandler.handleError(error);
            message.summary = 'REDO Error';
            this._messagesService.addErrorMessage(message);
          }
        );
      },
      reject: () => {
      }
    });
  }

  confirmRemoveBatch() {
    let dialogMessage = 'Do you really want to remove the Batch ' + this.searchedBatch.batchID + '?';
    this.confirmationService.confirm({
      message: dialogMessage,
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeBatch();
      },
      reject: () => {
      }
    });
  }

  removeBatch(){
    if(!['CREATE_BATCH', 'BATCH_UPLOADED', 'BATCH_RECEIVED','CONTROLS_ADDED'].includes(this.searchedBatch.statusOfTheBatch) && this.searchedBatch.workflowGroup != null && this.searchedBatch.workflowGroup === 'Midplex'){
      this._messagesService.addErrorMessage({
        severity: 'error',summary: 'Batch  Remove Error!',
        detail: 'Batch ' +this.searchedBatch.batchID+ ' cannot be removed, because its already in status "MERGING" or later.'
      });
      return;
    }
    this.blocked = true;
    this.apgAdminService.removeBatch(this.selectedLabId,this.searchedBatch.batchID,this.searchedBatch.workflowGroup).subscribe(
      result => {
        if (result.data) {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Removed!',
            detail: result.data,
          });
          this.searchedBatch.statusOfTheBatch = 'REMOVED';
          this.searchedBatch.version = this.searchedBatch.version + 1;
        }
        this.blocked = false;
      },
      error => {
        this.showError(error);
      }
    );
  }

  searchForSample(searchID: string) {
    if(['POS_EX', 'NTC_EX', 'PCR-PC', 'PCR-NTC'].includes(searchID)){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Barcode!', detail: 'Can not Search with Controls...Please enter a valid Sample Barcode'});
      return;
    }
    else if(searchID === 'NC-DUMMY'){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Barcode!', detail: 'Can not Search with NC-DUMMY...Please enter a valid Sample Barcode'});
      return;
    }
    this.blocked = true;
    this.apgAdminService.fetchSampleInfo(this.selectedLabId, searchID).subscribe(
      result => {
        if (result.data && result.data != null) {
          this.sampleInfo = result.data;
          this.commentsMap = new Map<string, Comment[]>();
          this.batchCommentVisibility = new Map<string, boolean>();
          this.batchID = this.sampleInfo.analysisBatch;
          this.sampleSearch = true;
        }
        else
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'No Data Found', detail: 'Sample Data not found for barcode ' + searchID});
        this.blocked = false;
      },
      error => {
        this.showError(error);
      }
    );
  }

  renameBatch(){
    this.searchedBatch.batchRenameEarly=false
    if(!['CREATE_BATCH', 'BATCH_UPLOADED', 'BATCH_RECEIVED'].includes(this.searchedBatch.statusOfTheBatch)){
      this._messagesService.addErrorMessage({
        severity: 'error',summary: 'Batch  Rename Error!',
        detail: 'Batch ' +this.newBatchID+ ' cannot be renamed, because its status is beyond BATCH_RECEIVED'
      });
      return;
    }
    this.searchedBatch.batchID = this.newBatchID;
    this.blocked = true;
    this.updateControlsWithNewBatchID();
    this.updateHistoryForBatch();
    this.updateCommentsWithNewbatchId();
    this.searchedBatch.batchRenameEarly=true

    this.apgAdminService.changeBatchStatus(this.searchedBatch).subscribe(
      result => {
        if (result.data) {
          this.searchedBatch = result.data;
          this.resetBatchData();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch ID Renamed!',
            detail: 'Batch ID renamed to '+this.searchedBatch.batchID+' from '+this.valueToSearch+' successfully'
          });
        this.blocked = false;
        this.newBatchID = "";
      }
      },
      error => {
        this.showError(error);
      }
    );
  }
  updateCommentsWithNewbatchId(){
    let comment:Comment[] = this.searchedBatch.comments;
    let newChange: Comment = {batchId:this.newBatchID, puid: this.puid,userComment: "Batch "+ this.valueToSearch+" has been renamed to "+this.searchedBatch.batchID+" by "+this.puid,commentDate: new Date()};
    comment.push(newChange);
    this.searchedBatch.comments = comment;
  }
  updateCommentsForBatchUpdate(statusOfBatch:string){
    let comment:Comment[] = this.searchedBatch.comments;
    let newChange: Comment = {batchId:this.searchedBatch.batchID, puid: this.puid,userComment: "Batch status has been changed from "+this.searchedBatch.statusOfTheBatch+" to "+statusOfBatch+" by "+this.puid,commentDate: new Date()};
    comment.push(newChange);
    this.searchedBatch.comments = comment;
  }
  updateControlsWithNewBatchID(){
    let sampleControls:CovidSamples[] = this.searchedBatch.samples;
    for(let control of sampleControls){
      if(control.positionRow == 7 && control.prositionCol == 12){
        control.barcode = 'KON00_'+this.newBatchID+'_NTC';
      }
      if(control.positionRow == 8 && control.prositionCol == 12){
        control.barcode = 'KON00_'+this.newBatchID+'_PC';
      }
    }
  }

  updateHistoryForBatch(){
    let batchHistory: BatchHistory[] = this.searchedBatch.history;
    let newChange: BatchHistory = {currentBatch:this.newBatchID, originalBatch: this.newBatchID};
    batchHistory.push(newChange);
    this.searchedBatch.history = batchHistory;
  }

  getDeliveryTargetDate(){
    if(!this.searchedBatch.batchReceivedDateTime){
      this.deliveryTargetDate = "NA";
    }
    else{
      let receivedDate: Date = new Date(this.searchedBatch.batchReceivedDateTime);
      this.deliveryTargetDate = this.addBusinessDays(receivedDate, 7);
   }
    return this.deliveryTargetDate;
  }

  //adding working days to given date
  addBusinessDays(d:Date, n:number) {
    d = new Date(d.getTime());
    var day = d.getDay();
    d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
    return d;
  }

  getPositionString(row: number, col: number) {
    if(row != undefined && col != undefined){
      return String.fromCharCode(64 + row) + col;
    }
  }

  getStyleForResult(result: string) {
    if (result && result.trim() != '') {
      if (result === 'positive')
        return {
          'color': 'red'
        };
      else if (result === 'negative')
        return {
          'color': 'green'
        };
      else
        return {
          'color': '#ffbf00'
        };
    }
  }

  getContaminationString(sampleInfo: any): string{
    let contaminationString = '';
    if(sampleInfo.contamination && sampleInfo.contamination != 'No Contamination'){
      contaminationString = sampleInfo.contamination;
      if(sampleInfo.contaminationComment && sampleInfo.contaminationComment.trim() != '')
        contaminationString = contaminationString + '( ' + sampleInfo.contaminationComment + ' )';
    }
    return contaminationString;
  }

  disableSearchIf(searchID: string): boolean{
    return !(this.selectedSearchFilter && searchID && searchID.trim()!='');
  }

  disableRenameButtonIf(): boolean{
    return !(this.newBatchID && this.newBatchID.trim()!='');
  }

  disableRenameFieldIf(): boolean{
    return ((this.searchedBatch.redoCount && this.searchedBatch.redoCount > 0) || this.searchedBatch.statusOfTheBatch == "REDO" || !this.validRole);
  }

  getCommentKeys(commentMap: Map<string, Comment>) {
    return Array.from(commentMap.keys());
  }

  toggleBatchContent(batchID: string, showState: boolean) {
    this.batchCommentVisibility.set(batchID, showState);
  }

  showComments(batchResult: boolean) {
    if(batchResult) {
      this.formCommentsMap(this.searchedBatch.comments, batchResult);
    } else {
      this.formCommentsMap(this.sampleInfo.comment, batchResult);
    }
    this.showCommentDialog = true;
  }

  formCommentsMap(comments: Comment[], batchResult: boolean) {
    if(!comments || this.commentsMap.size != 0) {
      return;
    }
    this.batchCommentVisibility = new Map<string, boolean>();
    comments.forEach(comment => {
      let cmnt = this.getArrayOfCommentsToAnother(comment.batchId, comment, batchResult);
      this.commentsMap.set(comment.batchId, cmnt);
      this.batchCommentVisibility.set(comment.batchId, true);
    });
  }

  getArrayOfCommentsToAnother(batchID: string, comment: Comment, batchResult: boolean) {
    let commentItem = this.commentsMap.get(batchID);
    if(!commentItem) {
      commentItem = [];
    }
    if(!batchResult) {
      comment.commentDate = comment.commentDate['$date'];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }

  deleteDisabledIf(){
    return !(this.batchIdToDeleteSample && this.batchIdToDeleteSample.trim() != '')
  }

  deleteSample(searchField: HTMLInputElement) {
    let dialogMessage = 'Do you really want to Delete the Sample ' + searchField.value + '?';
    this.confirmationService.confirm({
      message: dialogMessage,
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.blocked = true;
        this.apgAdminService.deleteSampleFromBatch(this.selectedLabId, searchField.value, this.batchIdToDeleteSample).subscribe(
          result => {
            searchField.value = null;
            this.sampleSearch = false;
            this.sampleInfo = null;
            this.batchIdPopup = false;
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Deleted Sample!', detail: result.data });
            this.blocked = false;
          },
          error => {
            this.showError(error);
          }
        );
      },
      reject: () => {
      }
    });
  }

  confirmFalseRedo(){
    this.confirmationService.confirm({
      message: 'Do you really want to Correct False Redo For Batch: ' + this.searchedBatch.batchID + '?',
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.blocked = true;
        this.apgAdminService.changeFalseRedo(this.selectedLabId, this.searchedBatch, this.searchedBatch.redoCount).subscribe(
          result => {
            this.searchedBatch = result.data;
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Corrected Redo!', detail: 'Redo has been changed to ' + this.searchedBatch.batchID });
            this.blocked = false;
          },
          error => {
            this.showError(error);
          }
        );
      },
      reject: () => {
      }
    });
  }

  setRedoStep(status: string, redoStep: string){
    this.selectedRedoStep = status;
    this.searchedBatch.redoStep = redoStep;
    if(this.searchedBatch.redoCount > 0 && redoStep == 'Redo_Lysis' && this.searchedBatch.batchID.substring(this.searchedBatch.batchID.lastIndexOf('_')).includes('L') && this.searchedBatch.swabType == 'Dry'){
      this.confirmationService.confirm({
        message: 'This Batch has already undergone Redo Lysis, Are you sure you want to attempt Redo Lysis again?',
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.redoReasonsPopup = true;
        },
        reject: () => {
        }
      });
    } else{
      this.redoReasonsPopup = true;
    }

  }

  redoButtonDisabledIf(){
    if(!this.selectedRedoReason)
      return true;
    else if(this.selectedRedoReason != 'Other')
      return false;
    else
      return !(this.enteredRedoReason && this.enteredRedoReason.trim() != '');
  }

  removeDisabledIf(): boolean{
    return !(this.searchedBatch  && !['COMPLETED', 'REMOVED'].includes(this.searchedBatch.statusOfTheBatch) && !this.isMergedBatch() && this.validRole)
  }

  removeUnnecessaryRedoDisabledIf(): boolean{
    return !(this.searchedBatch && this.searchedBatch.redoCount > 0 && !this.isMergedBatch() && this.validRole);
  }

  changeFalseRedoDisabledIf(): boolean{
    return !(this.searchedBatch && this.searchedBatch.redoCount > 0 && !['REDO', 'COMPLETED', 'REMOVED'].includes(this.searchedBatch.statusOfTheBatch) && !this.isMergedBatch() && !this.isRedoExtractionBatch() && this.validRole);
  }

  isMergedBatch(): boolean{
    return this.searchedBatch.wellType == WellType.WELL384;
  }


  removeUnnecessaryRedo() {
    let batchIdsTobeRemoved: string[] = [];
    let index = this.parentBatches.indexOf(this.selectedBatchIdToComplete) + 1;
    batchIdsTobeRemoved = this.parentBatches.slice(index, this.parentBatches.length);
    this.blocked = true;
    this.apgAdminService.removeUnnecessaryRedo(this.selectedLabId, this.selectedBatchIdToComplete, batchIdsTobeRemoved).subscribe(
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Batch Removed!',
          detail: result.data,
        });
        this.removeUnnecessaryPopup = false;
        this.selectedBatchIdToComplete = null;
        this.searchedBatch.statusOfTheBatch = 'REMOVED';
        this.searchedBatch.version = this.searchedBatch.version + 1;
        this.blocked = false;
      },
      error => {
        this.showError(error);
      }
    );
  }

  isRedoExtractionBatch() {
    if(this.searchedBatch.redoCount > 0) {
      let batchExtension = this.searchedBatch.batchID.substr(this.searchedBatch.batchID.lastIndexOf('_') + 1);
      return (batchExtension.charAt(batchExtension.length - 1) == 'E');
    }
    return false;
  }

  onResultFileChange(event) {
    if (event.target.files.length > 1) {
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Uploaded more than 1 files!',
        detail: 'Maximum of 1 file can be uploaded!',
      });
      return;
    }
    var file = event.target.files[0];
    this.readFileContent(file).then(
      (result) => {
        this.requestJson = result;
      },
      (_error) => {

        this._messagesService.addErrorMessage({
          severity: 'Error', summary: 'Error', detail: 'Error occurred while reading the file contents, please try again'
        })
      }
    )
  }

  readFileContent(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (!file) {
        resolve('');
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = reader.result.toString();
        resolve(text);
      };
      reader.readAsText(file);
    });
  }

  submitRequest() {
    this.blocked = true;
    let request
    try {
      request = JSON.parse(this.requestJson);
    } catch (error) {
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid JSON', detail: error.message
      })
      return;
    }
    if(this.searchSelection=='sendOrder'){
      this.apgAdminService.submitOrder(request).subscribe(
        (result) => {
          this.blocked = false;
          this._messagesService.addSuccessMessage(
            {
              severity: 'success', summary: 'Success',
              detail: 'Order has been accpeted'
            }
          )
        }, (error) => {
          this.blocked = false;
          if (error) {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          } else {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Failure',
              detail: 'Some unknown error, please try again'
            })
          }
        }
      )
    }else{
      if(!request || !request.delivery || request.delivery=='' || !request.sampleId || request.sampleId==''){
        this.blocked = false;
        this._messagesService.addWarningMessage(
          {severity: "warn", summary: "Invalid data",
          detail: "Following fields ['sampleId', 'delivery'] are mandatory to submit request, can't be either null or empty"}
        )
        return;
      }
      let eventEnvelope: EventEnvelope = {} as EventEnvelope;
      eventEnvelope.eventData = request;
      eventEnvelope.date = new Date();
      eventEnvelope.source = "Blueberry UI - Mock";
      eventEnvelope.destination = "Interface";
      eventEnvelope.eventType = "RESULT_UPDATED"
      this.apgAdminService.submitEvent(eventEnvelope).subscribe(
        (response)=>{
          this.blocked = false;
          this._messagesService.addSuccessMessage(
            {
              severity: 'success', summary: 'Success',
              detail: 'Order update request has been accepted'
            }
          )
        },
        (error)=>{
          this.blocked = false;
          if (error) {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          } else {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Failed',
              detail: 'Unknown error, please try again'
            })
          }
        }
      );
    }
  }


  searchInterface(searchID: string){
    if(!searchID || searchID==''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Search ID is empty',
        detail: 'Please input sample id and hit enter or click on Go'
      })
      return;
    }
    this.blocked = true;
    this.apgAdminService.fetchOrderBySampleID(searchID).subscribe(
      (response)=>{
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Success',
          detail: 'Successfully fetched orders information for sample '+searchID
        })
        document.getElementById("orderSearchJsonId").innerHTML = JSON.stringify(response.data, undefined, 2);
      },
      (error)=>{
        this.blocked = false;

        if (error && error.status=='404') {
          this._messagesService.addErrorMessage(
            {
              severity: 'error', summary: 'Order not found',
              detail: 'No order found with sampleId '+searchID
            }
          )
        } else if(error){
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Unknown error',
            detail: 'Failed to fetch requested information'
          })
        }
      }
    );
  }

  radioOnClick(event: any) {
   this.searchSuccess=false;
   this.sampleSearch=false;
  }

  updateBatchReceivedDate() {

   let updateBatchDateAndTime: UpdateBatchDateAndTimeDTO = {} as UpdateBatchDateAndTimeDTO;


    this.confirmationService.confirm({
        message: 'Are you sure that you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          updateBatchDateAndTime.puid=this.puid;
          updateBatchDateAndTime.batchId=this.batchID;

          if (this.searchedBatch.batchReceivedDateTime) {
               updateBatchDateAndTime.batchReceivedDateTime = this.dateValue;
               updateBatchDateAndTime.deliveryTargetDateTime = this.addBusinessDays(this.dateValue, 7);
               updateBatchDateAndTime.filterDateTime = this.dateValue;
               updateBatchDateAndTime.lab = this.selectedLabId;
          } else {

               this._messagesService.addWarningMessage(
                 {severity: "warn", summary: "Cant update the batch received date time as, batch has not yet been received in the lab",
                 detail: ""}
               )
               return;
         }

         this.blocked=true;
          this.apgAdminService.updateBatchTime(updateBatchDateAndTime).subscribe(
           (response)=>{
             this.blocked = false;
             this.searchedBatch = response.data;
             this.commentsMap = new Map<string, Comment[]>();
             this._messagesService.addSuccessMessage(
               {
                 severity: 'success', summary: 'Success',
                 detail: 'Covid19 batch update request has been accepted'
               }
             )
           },
           (error)=>{
             this.blocked = false;
             if (error) {
               let message = this.errorHandler.handleError(error);
               this._messagesService.addErrorMessage(message);
             } else {
               this._messagesService.addErrorMessage({
                 severity: 'error', summary: 'Failed',
                 detail: 'Unknown error, please try again'
               })
             }
           }
         );

        },
        reject: () => {

          this.dateValue = new Date(this.searchedBatch.batchReceivedDateTime);        }
    });



  }
  onTabChange(event){
    this.selectedTab = event.data
    if(event.data == 'batch'){
      setTimeout(() => {
        let element = document.getElementById("searchField");
        element.focus();​​​​​
        }​​​​​, 50);

    }
  }

  getFileUploadStyle() {
    return {
      'background-color': 'rgb(65, 130, 126)',
      'border': 'none',
      'height':'3rem'
    }
  }

  onCustomerFileSelect(event){
    if(event.files[0].name.split('.').pop() != "csv"){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only .csv files are allowed.',
      });
    }
  }

  onTemplateClick(){
    this.blocked = true;
    this.apgAdminService.downloadTemplate('change_tagsequence_template').subscribe(
      result => {
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, 'change_libraries.csv');
        this.blocked=false;
      },
      error => {
        this.blocked=false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary:'Upload Failed',
          detail:'Could not download template file..Please contact support!!'
        });
      }
    )
  }

  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    saveByFileSaver(blob, filename);
  }

  onCSVUpload(event, fileUploader: any){

    let formData = new FormData();
    formData.append('file', event.files[0]);
    formData.append('uploadType', "update_tagSeqeunce");

    let jsonObj = {};
    jsonObj['labId'] = this.selectedLabId;
    jsonObj['puid'] = this.puid;
    jsonObj['labName'] = this.selectedLab.name
    formData.append('requestData', JSON.stringify(jsonObj));
    this.blocked = true;
    this.apgAdminService.uploadCSVForLibraryUpdate(formData).subscribe(
      result=>{
        if(result.data['validation']){
          this.blocked = false;
          this._messagesService.addErrorMessage({
            severity:'error', summary:'Upload Failed',
            detail:result.data.validation
          })
        } else if(result.data['problemLibs'] && Object.keys(result.data['problemLibs']).length > 0){
          let message: string ='';
          if(result.data.problemLibs.covidLibs){
            message += 'Covid Libraries (' +  result.data.problemLibs.covidLibs.join(', ') + ')';
            jsonObj['covidLibs'] = result.data.problemLibs.covidLibs;
            if(result.data.problemLibs.pooledLibs)
              message += ' and ';
          }
          if(result.data.problemLibs.pooledLibs)
            message += 'Pooled Libraries (' + result.data.problemLibs.pooledLibs.join(', ') + ')';

          message +=  ' found while processing CSV file, Click Yes to proceed with the update OR No to terminate the process.'
          this.blocked = false;
          this.confirmationService.confirm({
            message: message,
            header: 'Confirmation',
            accept: () => {
              jsonObj['libraryData'] = result.data.libraryData;
              formData.set('requestData', JSON.stringify(jsonObj));
              this.blocked = true;
              this.apgAdminService.uploadCSVForLibraryUpdate(formData).subscribe(
                result =>{
                  this.blocked = false;
                  let successMsg = result.data;

                  this.saveWorkFile(event.files[0].name);

                  this._messagesService.addSuccessMessage({
                    severity:'success', summary:'CSV Uploaded',
                    detail: successMsg
                  })
                }, error=>{
                  fileUploader.clear()
                  this.blocked = false;
                  let message = this.errorHandler.handleError(error);
                  this._messagesService.addErrorMessage(message);
                }
              )
            },
            reject: () => {
              fileUploader.clear()
            }
          });
        } else{
          this.blocked = false;
          let successMsg = result.data;
          this.saveWorkFile(event.files[0].name);

          this._messagesService.addSuccessMessage({
            severity:'success', summary:'CSV Uploaded',
            detail: successMsg
          })
        }
        fileUploader.clear()
      }, error=>{
        fileUploader.clear()
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )

  }

  private saveWorkFile(filename: any) {
    let requestObj = {
      'fileName': filename,
      'labId': this.selectedLabId,
      'process': "Administration",
      'processStep':"Runs Data",
      'puid': this.puid
    };

    this.runplanProcessService.saveToWorkfiles(requestObj).subscribe(
      _result => { },
      error => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Upload Failed',
          detail: 'Could not upload template file..Please contact support!!'
        });
      }
    );
  }

  getDisabledForGoButton(){
    return (this.selectedRunSearch && this.inputRunId);
  }

  getDisabledForInput(){
    return this.selectedRunSearch;
  }

  getRunDetails(){
    this.blocked=true;
    this.selectedRun=new RunDetails();
    this.runMachine=null;
    this.runplanProcessService.getRunForLabAndRunId(this.selectedLabId, this.inputRunId.trim()).subscribe(
      result=>{
        if (result.data) {
          this.selectedRun = result.data;
          this.previewComment=this.getPreviewComment(this.selectedRun)
          this.runMachine =  null;
          this.startDate = this.selectedRun.planDate?new Date(this.selectedRun.planDate):null;
          this.runCommentsMap = new Map<string, RunComment[]>();
          this.runCommentVisibility = new Map<string, boolean>();
          this.runDetailShow=true;
          this.getMachineDetails();
          this.getFlowCellMap();
        } else {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Run Not Found', detail: 'Run not found with RunID ' + this.inputRunId });
        }
        this.blocked = false;
      }, error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
  getPreviewComment(run:RunDetails):RunComment
  {
    let comment=new RunComment()
    comment.runId=run.runId;
    comment.puid='';
    comment.commentDate=null;
    comment.userComment=null;
    if( run && run.comments)
    {
      if(run.comments.length !=0)
      {
     comment.puid= run.comments[run.comments.length-1].puid
     comment.commentDate=run.comments[run.comments.length-1].commentDate
     comment.userComment=run.comments[run.comments.length-1].userComment
      }
    }
    return comment
  }
  saveComment()
  {
    this.blocked = true;
    this.newRunComment.commentDate = new Date();
    this.newRunComment.userComment = this.newRunComment.userComment.trim();
    this.newRunComment.puid=this.puid
    this.runplanProcessService.saveComment(this.selectedRun.runId, this.selectedLabId ,this.newRunComment).subscribe(
      result => {
        this.blocked = false;
        this.selectedRun = result.data;
         let cmnt=this.getArrayOfRunCommentsToAnother(this.selectedRun.runId,this.newRunComment)
        this.runCommentsMap.set(this.selectedRun.runId, cmnt);
        this.runCommentVisibility.set(this.selectedRun.runId, true);
        this.previewComment=this.getPreviewComment(this.selectedRun)
        this.blocked = false;
        this.newRunComment =new RunComment()
        console.log(this.newRunComment);

        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Comment Saved', detail: 'Comment saved successfully' });
      },
      error=>
      {
        this.showError(error);
      }
      )

  }
  disableAddCommentButton():boolean
  {
    return this.newRunComment.userComment==null  ? true : false ;
  }

  disableCalendar(){
    return (!this.selectedRun || !this.selectedRun.status || this.selectedRun.status=='RUN_PLANNED');
  }

  getMachineDetails(){
    this.runMachineOptions=[];
    this.masterDataMDMService.getNamesForMachinesWithTypes(this.selectedRun.sequencerType, this.selectedLabId, true).subscribe(
      results=>{
        if(results.data){
          results.data.forEach(type => {
              this.runMachineOptions.push({label:type, value:type});
          })
        }

        this.initializeRunMachine();
      },error=>{
        this.runMachineOptions = [];
        this.errorHandlerMethod(error);
      }
    )
  }

  initializeRunMachine(){
      this.runMachineOptions.forEach(item=>{
        if(this.selectedRun && this.selectedRun.sequencerIntrument && item.value==this.selectedRun.sequencerIntrument){
          this.runMachine=item.value;
        }
      }
    )
  }

  updateRunDetails(){
    let request={
      'runDate': this.datepipe.transform(new Date(this.startDate).toUTCString(), 'yyyy-MM-dd HH:mm:SS'),
      'runId': this.selectedRun.runId,
      'machine': this.runMachine,
      'status' : this.selectedRun.status,
      'labId' : this.selectedRun.lab,
      'runEndDate' : this.datepipe.transform(new Date(this.selectedRun.plannedFinishDate).toUTCString(), 'yyyy-MM-dd HH:mm:SS'),
      'puid' : this.puid
    }

    this.apgAdminService.updateRun(request).subscribe(
      result => {
        if (result.data ==='Run details updated successfully!') {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: result.data,
            detail: '',
          });
        }else{
          this._messagesService.addSuccessMessage({
            severity: 'warn', summary: result.data,
            detail: '',
          });
        }
        this.runReschedulePopup=false;
      },error=>{
        this.errorHandlerMethod(error);
        this.runReschedulePopup=false;
      }
    )
  }

  rejectReschedule(){
    this.overlapRunList=[];
    this.runReschedulePopup=false;
  }

  checkOverlapRuns(){
    this.overlapRunList=[];
    let request={
      'runDate': this.datepipe.transform(new Date(this.startDate).toUTCString(), 'yyyy-MM-dd'),
      'runId': this.selectedRun.runId,
      'labId' : this.selectedLabId,
      'runEndDate' : this.datepipe.transform(new Date(this.selectedRun.plannedFinishDate).toUTCString(), 'yyyy-MM-dd'),
      'machine' : this.runMachine
    }

    this.apgAdminService.getOverlapRuns(request).subscribe(
      result=>{
        if (result.data) {

          this.overlapRunList=result.data.overlapRunList;
          this.runReschedulePopup=true;

        } else {
          this.runReschedulePopup=false;
          this.updateRunDetails();
        }
        this.blocked = false;
      }, error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }


  getRunCommentKeys(commentMap: Map<string, any>) {
    return Array.from(commentMap.keys());
  }

  initializeNewRunComment() {
    let comment = new RunComment();
    comment.runId = this.selectedRun.runId;
    comment.puid = this.puid;

    return comment;
  }

  showRunComments() {
    this.formRunCommentsMap(this.selectedRun.comments);
    this.newRunComment = this.initializeNewRunComment();
    this.previewComment=this.getPreviewComment(this.selectedRun)
    this.showRunCommentDialog = true;
  }

  getArrayOfRunCommentsToAnother(runID: string, comment: RunComment) {
    let commentItem = this.runCommentsMap.get(runID);
    if (!commentItem) {
      commentItem = [];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }

  toggleRunContent(runID: string, showState: boolean) {
    this.runCommentVisibility.set(runID, showState);
  }

  formRunCommentsMap(comments: any[]) {
    if (!comments || this.runCommentsMap.size != 0) {
      return;
    }
    this.runCommentVisibility = new Map<string, boolean>();
    comments.forEach(comment => {
      let cmnt = this.getArrayOfRunCommentsToAnother(this.selectedRun.runId, comment);
      this.runCommentsMap.set(this.selectedRun.runId, cmnt);
      this.runCommentVisibility.set(this.selectedRun.runId, true);
    });
  }


  getFlowCellMap(){
    this.runDuration=0;
    this.flowCellDurationMap = new Map<string, any>();
    this.runPlanSchedulerService.getFlowcellCapacity(this.selectedLabId, this.selectedRun.sequencerType).subscribe(
      result => {
        if(result.data && result.data.flowCellDurationMap) {
          this.flowCellDurationMap =  new Map(Object.entries(result.data.flowCellDurationMap));
          let runDurationMap = new Map(Object.entries(this.flowCellDurationMap.get(this.selectedRun.flowCellName)?this.flowCellDurationMap.get(this.selectedRun.flowCellName):new Object()));
          this.runDuration = runDurationMap.get(this.selectedRun.largestReadMode)?runDurationMap.get(this.selectedRun.largestReadMode):0;
          this.calculateRunFinishDate();
        }
      },
      error => {
        this.errorHandlerMethod(error);
      }
    );
  }

  calculateRunFinishDate(){
    let date = new Date(this.startDate);
    date.setHours(date.getHours() + this.runDuration);
    this.selectedRun.plannedFinishDate = date;
  }

  errorHandlerMethod(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  fetchDelivery(deliveryId: string) {
    this.fixdelivery = deliveryId;
    if (!deliveryId || deliveryId == '') {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Delivery ID is empty',
        detail: 'Please input delivery id and hit enter or click on Go'
      })
      return;
    }
    this.deliveryId = deliveryId;
    this.blocked = true;
    this.apgAdminService.fetchDeliveryInfo(deliveryId).subscribe(
      (response) => {
        this.blocked = false;
        this.deliveryOrdersList = (response.data || []).map((order: any) => {
          return Object.assign({}, order);
        });
        console.log("this.deliveryOrdersList  :", this.deliveryOrdersList)
        this.deliveryOrdersList.sort((data1: Order, data2: Order) => {
          console.log("data1  :", data1.sampleId);
          console.log("data1  :", data2.sampleId);
          return data1.sampleId.localeCompare(data2.sampleId);
        });

        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Delivery found',
          detail: 'Orders within delivery ' + deliveryId + ' fetched successfully'
        })
      }, (err) => {
        this.blocked = false;
        this.deliveryOrdersList = [];
        if (err && err.status == 404) {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Delivery not found',
            detail: 'No order found with delivery ' + deliveryId
          })
        } else {
          let message = this.errorHandler.handleError(err);
          this._messagesService.addErrorMessage(message);
        }
      }
    )
  }
  handleDeliveryRowSelect(event: any) {
    if (!this.selectedDeliveryOrder || !this.selectedDeliveryOrder.delivery || !this.selectedDeliveryOrder.sampleId) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Selected invalid order',
        detail: 'Could not find delivery and sample info for selected order, please refresh the delivery and try again'
      })
      return;
    }
    if (document.getElementById("deliveryOrderJsonId")) {
      document.getElementById("deliveryOrderJsonId").innerHTML = ""
    }
    this.blocked = true;
    this.apgAdminService.fetchOrder(this.selectedDeliveryOrder.delivery, this.selectedDeliveryOrder.sampleId).subscribe(
      (response) => {
        this.showDeliveryOrder = true;
        setTimeout(() => {
          this.blocked = false;
          document.getElementById("deliveryOrderJsonId").innerHTML = JSON.stringify(response.data, undefined, 2);
        }, 100)
      }, (err) => {
        this.blocked = false;
        if (err && err.status == 404) {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Order not found',
            detail: 'No order found with sample ' + this.selectedDeliveryOrder.sampleId + ' in delivery ' + this.selectedDeliveryOrder.delivery
          })
        } else {
          let message = this.errorHandler.handleError(err);
          this._messagesService.addErrorMessage(message);
        }
      }
    )
  }
  checkIfFieldIsDate(field) {
    if (field && this.dateFields.indexOf(field) != -1) {
      return true;
    }
    return false;
  }
  checkIfFieldIsBoolean(field) {
    if (field && this.boolenFields.indexOf(field) != -1) {
      return true;
    }
    return false;
  }

  checkIfFieldIsButton(field) {
    if (field && this.buttonFields.indexOf(field) != -1) {
      return true;
    }
    return false;
  }
  disableBUtton(data: any): boolean {
    return false;
  }
  disableBUtton2() {
    return false;
  }
  fetchInvoicedOrders() {
    if (!this.fromDate || !this.untilDate) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Invalid',
        detail: 'Please select both from and until dates'
      })
      return;
    }
    let from = this.datePipe.transform(this.fromDate, invoiceDateFormat);
    let until = this.datePipe.transform(this.untilDate, invoiceDateFormat);
    this.blocked = true;
    this.apgAdminService.fetchInvoicedOrders(from, until).subscribe(
      (response) => {
        this.blocked = false;
        this.deliveryOrdersList = (response.data || []).map((order: any) => {
          return Object.assign({}, order);
        });
        this.deliveryOrdersList.sort((data1: Order, data2: Order) => {
          return data1.sampleId.localeCompare(data2.sampleId);
        });
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Success',
          detail: 'Invoiced orders fetched successfully'
        })
      }, (err) => {
        this.blocked = false;
        this.deliveryOrdersList = [];
        if (err && err.status == 404) {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'No invoiced order found',
            detail: 'No invoiced order found within selected date range'
          })
        } else {
          let message = this.errorHandler.handleError(err);
          this._messagesService.addErrorMessage(message);
        }
      }
    )
  }

}
